import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'
import _imports_3 from '@/assets/images/user-4.jpg'
import _imports_4 from '@/assets/images/user-5.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two latest-transaction" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 p-4\"><h3 class=\"mb-0\">Latest Transaction</h3><select class=\"form-select month-select form-control w-135 bg-border-color border-color bg-transparent\" aria-label=\"Default select example\"><option selected>Last 30 days</option><option value=\"1\">Last 90 days</option><option value=\"1\">Last 1 year</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[40] || (_cache[40] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1" }, "Customer ID")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Customer Name"),
                _createElementVNode("th", { scope: "col" }, "Property"),
                _createElementVNode("th", { scope: "col" }, "Date"),
                _createElementVNode("th", { scope: "col" }, "Price"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Payment"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0015")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Sarah Johnson")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Industrial", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "2024-10-01", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "$500,000", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, "Completed")
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Master Card", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault3"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0099")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Michael Smith")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("td", null, "Office", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "2024-09-28", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", null, "$1,200,000", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-warning bg-opacity-10 text-warning p-2 fs-12 fw-normal" }, "Pending")
                ], -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", null, "Paypal", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault4"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0145")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Emily Brown")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("td", null, "Multi-Family", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, "2024-09-25", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", null, "$350,000", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-25 text-danger p-2 fs-12 fw-normal" }, "Cancel")
                ], -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "Wise", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault5"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0247")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Jason Lee")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("td", null, "Residential", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", null, "2024-09-22", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", null, "$220,000", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, "Completed")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", null, "Payoneer", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault6"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#TRE0299")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-44 rounded-2",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Ashley Davis")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("td", null, "Commercial", -1)),
                _cache[35] || (_cache[35] = _createElementVNode("td", null, "2024-09-20", -1)),
                _cache[36] || (_cache[36] = _createElementVNode("td", null, "$1,500,000", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, "Rejected")
                ], -1)),
                _cache[38] || (_cache[38] = _createElementVNode("td", null, "Credit Card", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          items: "05",
          total: "30",
          class: "p-4"
        })
      ])
    ])
  ]))
}